
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Onewaytaxiinpune() {



  const cardData =
  {
    keyword: 'One-Way Taxi in Pune',
    heading: 'SHREE Tours & Travels: One-Way Taxi in Pune',
    headingDescription: 'SHREE Tours & Travels offers a reliable One-Way Taxi in Pune, providing a hassle-free and affordable travel option for those looking to reach their destination without a return trip. Whether you are traveling to Mumbai, Nashik, Kolhapur, Shirdi, Mahabaleshwar, or any other city, our well-maintained Cabs and professional drivers ensure a safe and comfortable ride. With flexible booking options, on-time pickups and competitive fares, we make one-way travel easy and convenient. Choose SHREE Tours & Travels for the best one-way taxi service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "One-Way Taxi Pune",
      "description": "Travel conveniently with our one-way taxi service in Pune. We offer reliable, comfortable and affordable taxis to various destinations, ensuring a hassle-free journey."
    },
    {
      "name": "Pune to Mumbai One-Way Taxi",
      "description": "Book a one-way taxi from Pune to Mumbai for a comfortable and stress-free journey. Our taxis provide a smooth ride, ensuring timely arrival without hidden charges."
    },
    {
      "name": "Pune to Kolhapur One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Kolhapur? We offer a convenient and affordable solution with well-maintained vehicles and professional drivers for a smooth trip."
    },
    {
      "name": "Pune to Mahabaleshwar One-Way Taxi",
      "description": "Travel in comfort with our one-way taxi from Pune to Mahabaleshwar. Our experienced drivers and reliable vehicles ensure a pleasant journey to this beautiful hill station."
    },
    {
      "name": "Pune to Shirdi One-Way Taxi",
      "description": "Book a one-way taxi from Pune to Shirdi and experience a peaceful and comfortable ride. Our service is designed to provide a safe, timely and relaxing journey to the temple town."
    },
    {
      "name": "Affordable One-Way Taxi in Pune",
      "description": "Looking for an affordable one-way taxi in Pune? We provide budget-friendly taxi services without compromising on comfort or safety, ensuring a smooth ride to your destination."
    },
    {
      "name": "Private One-Way Taxi for Pune",
      "description": "Book a private one-way taxi from Pune for a personalized travel experience. Enjoy privacy, flexibility and comfort while traveling at your own pace."
    },
    {
      "name": "One-Way Taxi for Group Travel Pune",
      "description": "Traveling with a group? Our one-way taxi service for group travel in Pune ensures a comfortable and spacious ride, making your journey enjoyable and stress-free."
    },
    {
      "name": "Book One-Way Taxi in Pune",
      "description": "Easily book a one-way taxi in Pune through our user-friendly online platform. We offer timely pickups, well-maintained vehicles and experienced drivers for your convenience."
    },
    {
      "name": "Pune One-Way Cab Service",
      "description": "Our Pune one-way Cab service provides the perfect solution for a smooth and easy ride. Whether it's for business or leisure, we offer affordable options tailored to your needs."
    },
    {
      "name": "One-Way Taxi for Family in Pune",
      "description": "Book a one-way taxi for your family from Pune and enjoy a safe, comfortable and hassle-free ride. Our family-friendly vehicles ensure a relaxing journey for all."
    },
    {
      "name": "Pune One-Way Taxi Booking",
      "description": "Easily book a one-way taxi from Pune with our hassle-free booking process. Get timely pickups and professional service at the best rates for your journey."
    }
  ],
  "tableData": [
    ["- One-Way Taxi Pune", "- Pune to Mumbai One-Way Taxi"],
    ["- Pune to Kolhapur One-Way Taxi", "- Pune to Mahabaleshwar One-Way Taxi"],
    ["- Pune to Shirdi One-Way Taxi", "- Affordable One-Way Taxi in Pune"],
    ["- Private One-Way Taxi for Pune", "- One-Way Taxi for Group Travel Pune"],
    ["- Book One-Way Taxi in Pune", "- Pune One-Way Cab Service"],
    ["- One-Way Taxi for Family in Pune", "- Pune One-Way Taxi Booking"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Convenient One-Way Travel",
      "WhyChoosedescription": "Our one-way taxi service in Pune offers the perfect solution for your travel needs, allowing you to travel from Pune to your destination without the hassle of a round trip. Whether it's for business or leisure, we ensure a convenient and comfortable one-way journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We provide affordable and transparent pricing for our one-way taxi service in Pune. With no hidden charges, our competitive rates ensure you get the best value for your money. You pay only for your one-way trip, making it a cost-effective option for your travel."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced, ensuring that your one-way journey in Pune is safe, smooth and timely. They are well-versed in local routes and they focus on your comfort and safety, offering a professional service that exceeds your expectations."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "We ensure that all our vehicles are regularly serviced and maintained to provide a comfortable and safe ride for your one-way trip in Pune. Our fleet is equipped with modern amenities to ensure a smooth and enjoyable travel experience."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a one-way taxi in Pune with SHREE Tours & Travels is quick and hassle-free. You can easily book online via our user-friendly platform or contact our customer service team for assistance. We make sure that the booking process is seamless and convenient."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for one-way taxi services in Pune, so you can book your ride at any time that suits your travel plans. Whether you need an early morning pickup or a late-night ride, our round-the-clock service ensures we meet your needs."
    },
    {
      "WhyChooseheading": "Customized One-Way Trips",
      "WhyChoosedescription": "We understand that every traveler has unique needs. Our one-way taxi service is flexible, allowing us to tailor the trip to your schedule, preferences and route. Whether you need a quick transfer or a leisurely drive, we ensure a personalized experience."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority. We are committed to providing exceptional service for every one-way taxi ride in Pune. Our goal is to ensure you have a smooth, timely and enjoyable journey, leaving you satisfied with your travel experience every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a one-way taxi in Pune?",
        answer: "You can easily book your one-way taxi in Pune through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of taxis do you offer for one-way trips in Pune?",
        answer: "We offer a variety of vehicles for one-way trips in Pune, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates for one-way taxis in Pune inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a one-way taxi for any destination within Pune?",
        answer: "Yes, you can book a one-way taxi to any destination within Pune, as well as nearby cities and locations."
    },
    {
        question: "Do you provide drivers with the rental taxi for one-way trips in Pune?",
        answer: "Yes, all our taxis come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for one-way taxi bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for one-way taxi bookings in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for one-way taxi trips in Pune?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my one-way taxi in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a one-way taxi in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I had an excellent experience with SHREE Tours & Travels for my one-way taxi ride in Pune. The driver was professional and the trip was smooth and hassle-free.',
        name: 'Mr. Amit Deshmukh',
    },
    {
        text: 'The one-way taxi service in Pune was fantastic. The vehicle was clean and the driver was punctual, ensuring I reached my destination on time.',
        name: 'Miss. Priya Patil',
    }
];













  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a reliable one-way taxi in Pune with SHREE Tours & Travels. Enjoy affordable fares, private one-way taxis and group travel options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/one-way-taxi-pune.jpg",
    "https://shreetoursandtravels.in/img/one-way-taxi-pune-group.jpg"
  ],
  "priceRange": "₹2000 - ₹8000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/one-way-taxi-pune",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 850
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Deshmukh"
      },
      "datePublished": "2024-12-01",
      "reviewBody": "The one-way taxi service from Pune was fantastic. The driver was courteous and the ride was smooth. Highly recommend for anyone looking for a reliable one-way trip."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Rajendra Sharma"
      },
      "datePublished": "2024-12-10",
      "reviewBody": "Excellent service! The one-way taxi from Pune was affordable and comfortable. Will definitely book again for my next trip."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "One-Way Taxi Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/one-way-taxi-pune"
  },
  "keywords": "One-Way Taxi Pune, Pune to Mumbai One-Way Taxi, Pune to Kolhapur One-Way Taxi, Pune to Mahabaleshwar One-Way Taxi, Pune to Shirdi One-Way Taxi, Affordable One-Way Taxi in Pune, Private One-Way Taxi for Pune, One-Way Taxi for Group Travel Pune, Book One-Way Taxi in Pune, Pune One-Way Cab Service, One-Way Taxi for Family in Pune, Pune One-Way Taxi Booking"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>One-Way Taxi Service in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a reliable one-way taxi in Pune with SHREE Tours & Travels. Enjoy affordable fares, private one-way taxis and group travel options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="One-Way Taxi Pune, Pune to Mumbai One-Way Taxi, Pune to Kolhapur One-Way Taxi, Pune to Mahabaleshwar One-Way Taxi, Pune to Shirdi One-Way Taxi, Affordable One-Way Taxi in Pune, Private One-Way Taxi for Pune, One-Way Taxi for Group Travel Pune, Book One-Way Taxi in Pune, Pune One-Way Cab Service, One-Way Taxi for Family in Pune, Pune One-Way Taxi Booking" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onewaytaxiinpune;